export default __webpack_public_path__ + "static/media/logo-dark.b628a4a5.jpeg";